import React from 'react'
import IconPrinterWarningAlt from '@veneer/core/dist/esm/scripts/icons/icon_printer_warning_alt'
import IconQRCode from '@veneer/core/dist/esm/scripts/icons/icon_qr_code'
import IconPersonAssist from '@veneer/core/dist/esm/scripts/icons/icon_person_assist'
import IconHelp from '@veneer/core/dist/esm/scripts/icons/icon_help'
import IconInfo from '@veneer/core/dist/esm/scripts/icons/icon_info'
import IconDocumentScanWithPrimaryColor from '@veneer/core/dist/esm/scripts/icons/icon_document_scan'
import IconDocumentScan from '@veneer/core/dist/esm/scripts/icons/icon_document_scan'
import IconMobileFax from '@veneer/core/dist/esm/scripts/icons/icon_mobile_fax'
import IconCloudService from '@veneer/core/dist/esm/scripts/icons/icon_cloud_service'
import IconSmartTasks from '@veneer/core/dist/esm/scripts/icons/icon_smart_tasks'
import IconInk from '@veneer/core/dist/esm/scripts/icons/icon_ink'
import IconPrinter from '@veneer/core/dist/esm/scripts/icons/icon_printer'
import IconXCircle from '@veneer/core/dist/esm/scripts/icons/icon_x_circle'
import IconWifi100 from '@veneer/core/dist/esm/scripts/icons/icon_wifi_100'
import IconTools from '@veneer/core/dist/esm/scripts/icons/icon_tools'
import IconDocumentCopy from '@veneer/core/dist/esm/scripts/icons/icon_document_copy'
import IconCaretRight from '@veneer/core/dist/esm/scripts/icons/icon_caret_right'
import IconExternalLink from '@veneer/core/dist/esm/scripts/icons/icon_external_link'

export const iconMapper = {
  icon_printer_warning_alt: <IconPrinterWarningAlt className="icon" />,
  icon_qr_code: <IconQRCode className="icon" />,
  icon_person_assist: <IconPersonAssist className="icon" />,
  icon_help: <IconHelp className="icon" />,
  icon_info: <IconInfo className="icon" />,
  icon_wifi100: <IconWifi100 className="icon" />,
  icon_x_circle: <IconXCircle className="icon" />,
  icon_document_scan: <IconDocumentScan className="icon" />,
  icon_mobile_fax: <IconMobileFax className="icon" />,
  icon_cloud_service: <IconCloudService className="icon" />,
  icon_smart_tasks: <IconSmartTasks className="icon" />,
  icon_ink: <IconInk className="icon" />,
  icon_printer: <IconPrinter className="icon" />,
  icon_tools: <IconTools className="icon" />,
  icon_caret_right_filled: <IconCaretRight className="icon" filled />,
  icon_document_copy: <IconDocumentCopy className="icon" />,
  icon_help_with_primary_color: <IconHelp color="#0073A8" className="icon" />,
  icon_document_scan_with_primary_color: (
    <IconDocumentScanWithPrimaryColor color="#0073A8" className="icon" />
  ),
  icon_external_link: <IconExternalLink className="icon" />,
  icon_custom_cancel: (
    <img
      src="https://images.contentstack.io/v3/assets/bltbd278b8fc62d8a81/bltbe16ce1caffa5405/6a0af3783ebcf73f96bf389a/Cancel_button_Icon_24X24px.svg"
      alt="Cancel button icon"
    />
  ),
  icon_custom_info: (
    <img
      src="https://images.contentstack.io/v3/assets/bltbd278b8fc62d8a81/blte2e39d633b644fdb/6a0af37894c79e7622263803/Info_button_Icon_24X24px.svg"
      alt="Info button icon"
    />
  ),
  icon_custom_wi_fi_gear: (
    <img
      src="https://images.contentstack.io/v3/assets/bltbd278b8fc62d8a81/blta7ec0fae9967f0ff/6a0af37852ed4636884ae456/Wi-fi_Gear_Icon_24X24px.svg"
      alt="WiFi gear icon"
    />
  ),
  icon_custom_wi_fi: (
    <img
      src="https://images.contentstack.io/v3/assets/bltbd278b8fc62d8a81/bltb073699f9120cd35/6a0af37807fd9712c4759ab1/Wifi_Icon_24X24px.svg"
      alt="WiFi icon"
    />
  ),
  icon_custom_wi_fi_blue: (
    <img
      src="https://images.contentstack.io/v3/assets/bltbd278b8fc62d8a81/blt3d42000cf0f2b5f4/6a0af3789889ff11740bcf42/WiFI-Blue_colored_Icon_24X24px.svg"
      alt="WiFi icon with blue color"
    />
  )
}
